import { render, staticRenderFns } from "./ExcelClients.vue?vue&type=template&id=b3774eb0&scoped=true&"
import script from "./ExcelClients.vue?vue&type=script&lang=js&"
export * from "./ExcelClients.vue?vue&type=script&lang=js&"
import style0 from "./ExcelClients.vue?vue&type=style&index=0&id=b3774eb0&scoped=true&lang=css&"
import style1 from "./ExcelClients.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3774eb0",
  null
  
)

export default component.exports